import logoWhiteOther from "@/assets/logoWithName-colors.svg";
import useTranslation from "@babackapp/translations/use-translation";

export const NoShopFound = () => {
  const t = useTranslation();
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="flex flex-col items-center justify-center space-y-4">
        <img className="h-20 w-auto" src={logoWhiteOther} alt="Logo Baback" />

        <div className="text-center ">
          <h3 className="text-primary text-xl mb-2 pl-10">
            {t("home.noShopTitle")}
          </h3>
          <p className="text-gray-600 pl-10">{t("home.noShopDescription")}</p>
        </div>
      </div>
    </div>
  );
};
